export default class LocalCache {
  constructor (key) {
    this.key = `${key}-${LocalCache.key}`
  }
  setCache (value = 1) {
    window.localStorage.setItem(this.key, value)
  }
  get cacheValue () {
    return window.localStorage.getItem(this.key)
  }
  get isCache () {
    return Boolean(this.cacheValue)
  }
}
LocalCache.key = 'LocalCache'
